import AdminIndex from './admin/admin-index.vue';

import PartnerIndex from './admin/partner/partner-index.vue';
import PartnerInformations from './admin/partner/partner-informations.vue';
import PartnerManagingList from './admin/partner/partner-managing-list.vue';
import PartnerEstablishmentList from './admin/partner/partner-establishment-list.vue';
import PartnerUserList from './admin/partner/partner-user-list.vue';

import ManagingIndex from './admin/managing/managing-index.vue';
import ManagingInformations from './admin/managing/managing-informations.vue';
import ManagingEstablishmentList from './admin/managing/managing-establishment-list.vue';
import ManagingUserList from './admin/managing/managing-user-list.vue';

import EstablishmentIndex from './admin/establishment/establishment-index.vue';
import EstablishmentInformations from './admin/establishment/establishment-informations.vue';
import EstablishmentGroupList from './admin/establishment/establishment-group-list.vue';
import EstablishmentUserList from './admin/establishment/establishment-user-list.vue';

import GroupIndex from './admin/group/group-index.vue';
import GroupInformations from './admin/group/group-informations.vue';
import GroupUserList from './admin/group/group-user-list.vue';

import UserIndex from './admin/user/user-index.vue';
import UserInformations from './admin/user/user-informations.vue';
import UserEstablishmentList from './admin/user/user-establishment-list.vue';

import PcrEstablishmentTree from './visual/pcr-establishment-tree.vue';
import PcrBreadcrumb from './visual/pcr-breadcrumb.vue';
import PcrCurrentTitle from './visual/pcr-current-title.vue';
import AdminEstablishmentContextualMenu from './admin/admin-establishment-contextual.vue';

import SystemIndex from './admin/system/system-index.vue';
import SystemSQLAdmin from './admin/system/system-sql-admin.vue';
import SystemMenu from './admin/system/system-menu.vue';
import SystemPartnerList from './admin/system/system-partner-list.vue';
import SystemUserList from './admin/system/system-user-list.vue';

import RingLoader from './admin/cross-components/ring-loader.vue';
import AddEstablishmentModal from './admin/cross-components/add-establishment-modal.vue';
import MoveEstablishmentModal from './admin/cross-components/move-establishment-modal.vue';
import SetAccessEstablishmentModal from './admin/cross-components/set-access-establishment-modal.vue';
import AddUserModal from './admin/cross-components/add-user-modal.vue';
import ChangeUserGrantLevelModal from './admin/cross-components/change-user-grant-level-modal.vue';
import ChangePasswordUserModal from './admin/cross-components/change-password-user-modal.vue';
import ChangeUserRoleModal from './admin/cross-components/change-user-role-modal.vue';
import RemoveUserToGroup from './admin/cross-components/remove-user-to-group.vue';
import RemoveEstablishment from './admin/cross-components/remove-establishment.vue';
import RemoveGroup from './admin/cross-components/remove-group.vue';
import DeleteUser from './admin/cross-components/delete-user.vue';

import PcrClientEstablishmentDetails from './client/pcr-client-establishment-details.vue';
import PcrClientRecallSettings from './client/pcr-client-recall-settings.vue';

import PcrUserState from './visual/pcr-user-state.vue';
import PcrGrantLevelLabel from './visual/pcr-grant-level-label.vue';
import CkInformations from './visual/ck-informations.vue';
import CkForm from './ck-form/ck-form.vue';
import CkFormItem from './ck-form/ck-form-item.vue';
import CkValidator from './ck-form/ck-validator.vue';
import CkValidators from './ck-form/ck-validators.vue';

export {
    AdminIndex
    ,AddEstablishmentModal
    ,MoveEstablishmentModal
    ,SetAccessEstablishmentModal
    ,AddUserModal
    ,ChangePasswordUserModal
    ,ChangeUserRoleModal
    ,ChangeUserGrantLevelModal
    ,RemoveUserToGroup
    ,RemoveEstablishment
    ,RemoveGroup
    ,DeleteUser

    ,PcrEstablishmentTree
    ,PcrBreadcrumb
    ,PcrCurrentTitle
    ,AdminEstablishmentContextualMenu

    ,PartnerIndex
    ,PartnerInformations
    ,PartnerManagingList
    ,PartnerEstablishmentList
    ,PartnerUserList

    ,SystemIndex
    ,SystemSQLAdmin
    ,SystemMenu
    ,SystemPartnerList
    ,SystemUserList
    
    ,ManagingIndex
    ,ManagingInformations
    ,ManagingEstablishmentList
    ,ManagingUserList
    
    ,EstablishmentIndex
    ,EstablishmentInformations
    ,EstablishmentGroupList
    ,EstablishmentUserList
    
    ,GroupIndex
    ,GroupInformations
    ,GroupUserList
    
    ,UserIndex
    ,UserInformations
    ,UserEstablishmentList

    ,PcrClientEstablishmentDetails
    ,PcrClientRecallSettings

    ,PcrUserState
    ,PcrGrantLevelLabel
    ,CkInformations
    ,CkForm
    ,CkFormItem
    ,CkValidator
    ,CkValidators
}


// WEBPACK FOOTER //
// ./src/components/index.js